import React from 'react';
import TableLiterature from '../../components/TableLiterature/TableLiterature';

const Literature = () => {
  return (
    <div>
      <div className="m-2 md:m-10 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista e literaturave</p>
        <TableLiterature />
      </div>
    </div>
  );
};

export default Literature;